<div class="popup-global-layout width-650 p-4 p-md-5">
  <div class="d-flex justify-content-end"><mat-icon class="icon" (click)="close()">close</mat-icon></div>
  <div class="global-title-doc-req">{{ 'claims.list.Claimstable.docNeeded' | translate }}</div>
  <div class="global-green-bar-doc-req"></div>
  <div class="global-text-doc-req">{{ 'claims.list.Claimstable.docNeededPopupText' | translate }}</div>
  <ul class="ul-doc-req">
    <li *ngFor="let item of data.docs">{{item}}</li>
  </ul>
  <div class="global-button-format">
      <button type="button" class="upsc-green-popup-button" (click)="close()">{{ 'claims.list.Claimstable.docNeededPopupButton' | translate }}<mat-icon class="icon-key2">keyboard_arrow_right</mat-icon></button>
  </div>
</div>